var React = require('react');

function GroupChevronInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Group_203","data-name":"Group 203","transform":"translate(-666.749 -2169.483)"},[React.createElement("path",{"id":"Path_236","data-name":"Path 236","d":"M12.96,6.944,12.016,6,8,10.016l4.016,4.016.944-.944L9.894,10.016Z","transform":"translate(688.708 2183.516) rotate(180)","fill":"#fff","key":0}),React.createElement("path",{"id":"Path_237","data-name":"Path 237","d":"M12.96,6.944,12.016,6,8,10.016l4.016,4.016.944-.944L9.894,10.016Z","transform":"translate(658.749 2163.483)","fill":"#fff","key":1})]));
}

GroupChevronInline.defaultProps = {"width":"13.96","height":"8.032","viewBox":"0 0 13.96 8.032"};

module.exports = GroupChevronInline;

GroupChevronInline.default = GroupChevronInline;
